import { render, staticRenderFns } from "./FamilyInformation.vue?vue&type=template&id=cb505466"
import script from "./FamilyInformation.vue?vue&type=script&lang=js"
export * from "./FamilyInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports